namespace $.$$ {

	$mol_style_define( $shm_ba_filter_list, {
		display: 'flex',
		flex: {
			direction: 'column',
		},

		Actions: {
			display: 'flex',
			justifyContent: 'space-between',
			gap: '8px',
			padding: {
				top: '4px',
			},
		},

		More: {
			minHeight: 0,
			minWidth: 0,
			padding: {
				left: '8px',
				right: '8px',
				top: '2px',
				bottom: '2px',
			},
			font: {
				size: '12px',
			},
		},

		Collapse: {
			minHeight: 0,
			minWidth: 0,
			margin: {
				left: 'auto',
			},
			padding: {
				left: '8px',
				right: '8px',
				top: '2px',
				bottom: '2px',
			},
			font: {
				size: '12px',
			},
		},
	} )

}
